import PropTypes from 'prop-types';
import React from 'react';

import Communicator from 'models/communicator';
import connect from 'components/lib/connect';
import ItemIcon from './item_icon';

export function OutboundIcon({ avatar, itemType, itemSubType, name, showIcon }) {
  return (
    <ItemIcon
      avatar={avatar}
      className="conversationItem-outboundIcon"
      itemType={itemType}
      itemSubType={itemSubType}
      name={name}
      showIcon={showIcon}
    />
  );
}

function mapStateToProps({ getProvider }, { initiator, itemType, itemSubType, showIcon }) {
  const agentId = initiator.type === Communicator.AGENT && initiator.id;
  const agent = getProvider('agents').findBy({ id: agentId });

  const avatar = agent && agent.avatarUrl;
  const name = agent && agent.name;

  return {
    avatar,
    itemType,
    itemSubType,
    name,
    showIcon,
  };
}

function mergeProps(stateProps, execProps, ownProps) {
  return Object.assign({}, stateProps);
}

OutboundIcon.propTypes = {
  avatar: PropTypes.string,
  itemType: PropTypes.string.isRequired,
  itemSubType: PropTypes.string,
  name: PropTypes.string,
  showIcon: PropTypes.bool,
};

const OutboundIconContainer = connect(mapStateToProps, null, mergeProps)(OutboundIcon);

OutboundIconContainer.propTypes = {
  itemType: PropTypes.string.isRequired,
  initiator: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string.isRequired,
  }).isRequired,
  showIcon: PropTypes.bool,
};

export default OutboundIconContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/icon/outbound_icon.jsx